const CHECKOUT_ORIGIN = 'https://the-complete-art-year.impultienda.ar';

let preconnected = false;

export function preconnectCheckout() {
  if (preconnected || typeof document === 'undefined') return;
  preconnected = true;
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = CHECKOUT_ORIGIN;
  document.head.appendChild(link);
}
